import { ButtonAccent } from "components/Atoms/Button";
import { useOpenNewProductionSidePanel } from "components/SidePanel/Production/NewProductionSidePanel";
import React from "react";

const NewProduction = () => {
  const openNewProductionSidePanel = useOpenNewProductionSidePanel();

  return <>
    <ButtonAccent
      label={RESX.GeneralLabels.resxNew}
      onClick={() => { openNewProductionSidePanel({ onCreated: () => { } }); }}
    />
  </>;
};

export default NewProduction;